import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "components/Header";
import Footer from "components/Footer";
import "./notfound.css";

const NotFound = () => {
  const [glitchText, setGlitchText] = useState("404");

  useEffect(() => {
    const glitchChars = "!<>-_\\/[]{}—=+*^?#________";
    let iteration = 0;

    const interval = setInterval(() => {
      setGlitchText((prev) =>
        prev
          .split("")
          .map((char, index) => {
            if (index < iteration) {
              return "404"[index];
            }
            return glitchChars[Math.floor(Math.random() * glitchChars.length)];
          })
          .join("")
      );

      if (iteration >= 3) {
        clearInterval(interval);
      }

      iteration += 1 / 3;
    }, 30);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="not-found-container">
      <Header />
      <div className="not-found">
        <div className="terminal-window">
          <div className="terminal-header">
            <div className="terminal-buttons">
              <span className="btn-close"></span>
              <span className="btn-minimize"></span>
              <span className="btn-maximize"></span>
            </div>
            <div className="terminal-title">error@terminal:~</div>
          </div>
          <div className="terminal-content">
            <div className="error-code">
              <span className="glitch" data-text={glitchText}>
                {glitchText}
              </span>
            </div>
            <pre className="error-ascii">{`
  ███████╗██████╗ ██████╗  ██████╗ ██████╗
  ██╔════╝██╔══██╗██╔══██╗██╔═══██╗██╔══██╗
  █████╗  ██████╔╝██████╔╝██║   ██║██████╔╝
  ██╔══╝  ██╔══██╗██╔══██╗██║   ██║██╔══██╗
  ███████╗██║  ██║██║  ██║╚██████╔╝██║  ██║
  ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝
            `}</pre>
            <div className="error-message">
              <p className="prompt-line">
                <span className="prompt">$</span> ls -la /page
              </p>
              <p className="error-text">
                ls: cannot access '/page': No such file or directory
              </p>
              <p className="prompt-line">
                <span className="prompt">$</span> echo $STATUS
              </p>
              <p className="status-text">
                ERROR: Resource not found in filesystem
              </p>
              <p className="prompt-line">
                <span className="prompt">$</span> cat suggestions.txt
              </p>
              <p className="suggestion-text">
                » The page you're looking for has been moved or deleted
              </p>
              <p className="suggestion-text">» Check the URL for typos</p>
              <p className="suggestion-text">» Or return to safety...</p>
            </div>
            <Link to="/" className="home-link">
              <span className="prompt">$</span> cd /home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
